// src/utils/crypto.js
import CryptoJS from 'crypto-js';

export function encrypt(data) {
    let text = JSON.stringify(data);
    text = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text)).toString();
    let key = CryptoJS.enc.Utf8.parse('JxKj0OO0ooO0JhKJ'); // 16位密钥
    let iv = CryptoJS.enc.Utf8.parse('JxKj0OO0ooO0JhKJ'); // 16位初始向量
    let encrypted = CryptoJS.AES.encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    }).toString();
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted)).toString();
}